import { createSlice } from '@reduxjs/toolkit';
import { GetRankedCryoboxesState } from './types';
import { StoreStatus } from '../../core/types/common.types';
import { getRankedCryoboxesThunk } from './thunks';

// Initial State
const initialState: GetRankedCryoboxesState = {
  errors: null,
  status: StoreStatus.IDLE,
  response: null,
};

// Slice
export const getRankedCryoboxesSlice = createSlice({
  name: 'getRankedCryoboxes',
  initialState,
  reducers: {
    setValues: (state, action) => ({
      ...state,
      values: action.payload,
    }),
    reset: () => ({
      ...initialState,
    }),
  },
  extraReducers: (builder) => {
    builder.addCase(getRankedCryoboxesThunk.pending.type, (state) => {
      state.status = StoreStatus.BUSY;
    });
    builder.addCase(getRankedCryoboxesThunk.fulfilled.type, (state, action: any) => {
      state.status = StoreStatus.IDLE;
      state.response = action.payload;
      state.errors = null;
    });
    builder.addCase(getRankedCryoboxesThunk.rejected.type, (state, action: any) => {
      state.status = StoreStatus.ERROR;
      state.errors = action.payload;
      state.response = null;
    });
  },
});

// Action creators
export const { reset, setValues } = getRankedCryoboxesSlice.actions;
export * from './thunks';
export * from './selectors';
export default getRankedCryoboxesSlice.reducer;
